import { useEffect, useRef, useState } from "react";
import type { LabelsApi } from "./labels-api";
import { uiFault } from "./labels-api";
import { labelPinSetupValueSchema } from "../../../shared/labels/contracts";

export function useLabelPinWorkspace({ api, refresh }: { api: LabelsApi; refresh: () => void }) {
  const [pin, setPin] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const pending = useRef<AbortController | null>(null);
  const mounted = useRef(false);
  useEffect(() => {
    mounted.current = true;
    return () => { mounted.current = false; pending.current?.abort(); };
  }, []);

  async function submit() {
    if (pending.current) return;
    setError("");
    const pinSchema = labelPinSetupValueSchema;
    if (!pinSchema.safeParse(pin).success) { setError("PIN'inizi 4 hane olarak girin."); return; }
    const controller = new AbortController();
    pending.current = controller;
    setBusy(true);
    try {
      await api.loginPin(pin, controller.signal);
      if (mounted.current && !controller.signal.aborted) {
        refresh();
      }
    } catch (cause: unknown) {
      if (mounted.current && !controller.signal.aborted) setError(uiFault(cause).message);
    } finally {
      if (pending.current === controller) pending.current = null;
      if (mounted.current) { setBusy(false); setPin(""); }
    }
  }

  return { pin, setPin, busy, error, clearError: () => setError(""), submit };
}

export function useLabelPinLogout({ api, refresh }: { api: LabelsApi; refresh: () => void }) {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const pending = useRef<AbortController | null>(null);
  const mounted = useRef(false);
  useEffect(() => {
    mounted.current = true;
    return () => { mounted.current = false; pending.current?.abort(); };
  }, []);
  async function logout() {
    if (pending.current) return;
    const controller = new AbortController();
    pending.current = controller;
    setBusy(true); setError("");
    try {
      await api.logoutPin(controller.signal);
      if (mounted.current && !controller.signal.aborted) refresh();
    } catch (cause: unknown) {
      if (mounted.current && !controller.signal.aborted) setError(uiFault(cause).message);
    } finally {
      pending.current = null;
      if (mounted.current) setBusy(false);
    }
  }
  return { busy, error, logout };
}
